import { createContext } from 'react';

/**
 * Whether the arche page under the route guard is at its DESTINATION.
 *
 * `ConditionalProtectedRoute` keeps the page mounted while it re-checks a new
 * `:id` (so a plugin's <iframe> survives one arche opening another) and across
 * the `arc_<id>` → slug canonicalizing redirect. During those renders the URL
 * segment the page sees is a WAYPOINT: it may be about to change (a raw id the
 * guard will rewrite to the slug) or about to be refused. `'pending'` says so;
 * `'settled'` means the guard has resolved this segment and is showing it.
 *
 * Read by things that must count a visit once, under the key a cold load would
 * use — the `arche_opened` / `arche_left` analytics in ArcheInteractionPage.
 * Defaults to `'settled'`, so a page rendered without the guard (tests,
 * previews) behaves as before.
 */
export type ArcheRouteStatus = 'settled' | 'pending';

export const ArcheRouteStatusContext = createContext<ArcheRouteStatus>('settled');
